import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ValueGetterPipe } from './value-getter.pipe';
import { ObjectBuilderPipe } from './object-builder.pipe';

@NgModule({
  declarations: [ValueGetterPipe, ObjectBuilderPipe],
  imports: [CommonModule],
  exports: [ValueGetterPipe, ObjectBuilderPipe]
})
export class AvanoPipesModule {}
